import { Modal } from "flowbite-react";
import { useEffect, useState } from "react";
import Loading from "../../../../common/components/ui/loading/Loading";
import PendenciesLead from "../PendenciesLead";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import { ILead } from "../../../../types/lead.type";
import {
  formatLeadApiError,
  getLeadById,
  updateLead,
  updateLeadProps,
} from "../../../../common/services/leads.api";
import FormEditLead from "../forms/FormEditLead";
import FormEditLeadByAmbassador from "../forms/FormEditLeadByAmbassador";
import { IIndicators } from "../../../../types/Indicators.type";

type Props = {
  leadId: null | string;
  onClose: () => void;
  ambassador?: IIndicators;
};

export default function ModalEditLead(props: Props) {
  const [leadId, setLeadId] = useState<string | null>(null);
  const { showToast } = useToastContext();
  const [leadData, setLeadData] = useState<ILead | null>(null);
  const [formRequestErrors] = useState([]);

  const notifySuccess = (text) => showToast({ text, type: "success" });
  const notifyError = (text) => showToast({ text, type: "error" });

  const handleCloseModal = () => {
    props.onClose();
  };

  useEffect(() => {
    props.leadId !== leadId && setLeadId(props.leadId);
  }, [props.leadId, leadId]);

  useEffect(() => {
    async function loadLeadData(leadId: string) {
      if (!leadId) return;

      const { data, ok } = await getLeadById(leadId);

      if (ok) {
        setLeadData(data as ILead);
      }
    }

    setLeadData(null);

    if (leadId) loadLeadData(leadId);
  }, [leadId]);

  async function saveLead(dataToSave: ILead) {
    try {
      const response = await updateLead(leadId as string, dataToSave);
      const { ok, data, errors } = response;
      

      if (ok && data) {
        setLeadData(data as ILead);
        notifySuccess(`Lead "${leadData?.name}" atualizado!`);
        return {
          ok,
          data: data as ILead,
          errors: errors as [{ message: string; path: string[] }],
        };
      }

      if (!response.ok) {
        notifyError(formatLeadApiError(response, "Erro ao tentar salvar Lead."));
      }

      return {
        ok,
        data: data as ILead,
        errors: errors as [{ message: string; path: string[] }],
      };
    } catch (err) {
      console.log(err);
      notifyError("Erro ao tentar salvar Lead, tente novamente");
      return {
        ok: false,
        data: dataToSave,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }],
      };
    }
  }
  async function saveLeadByAmbassador(dataToSave: ILead) {
    try {
      const response = await updateLeadProps(leadId as string, dataToSave);
      const { ok, data, errors } = response;
      if (ok && data) {
        setLeadData(data as ILead);
        notifySuccess(`Lead "${leadData?.name}" atualizado!`);
        return {
          ok,
          data: data as ILead,
          errors: errors as [{ message: string; path: string[] }],
        };
      }

      if (!response.ok) {
        notifyError(formatLeadApiError(response, "Erro ao tentar salvar Lead."));
      }

      return {
        ok,
        data: data as ILead,
        errors: errors as [{ message: string; path: string[] }],
      };
    } catch (err) {
      console.log(err);
      notifyError("Erro ao tentar salvar Lead, tente novamente");
      return {
        ok: false,
        data: dataToSave,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }],
      };
    }
  }
  
  return (
    <>
      <Modal
        size={"5xl"}
        className="relative dark:text-black"
        show={true}
        onClose={() => handleCloseModal()}
      >
        <Modal.Header>
          <div className="flex items-center justify-start gap-3 dark:text-black">
            <span>{`Editando: ${(leadData || {})?.name}`}</span>
            {leadData ? (
              <PendenciesLead placement="bottom" lead={leadData} />
            ) : null}
          </div>
        </Modal.Header>

        <Modal.Body
          className="w-full relative border-gray flex flex-col"
          style={
            !props.ambassador
              ? {
                minHeight: "calc(100vh - 300px)",
                height: "calc(100vh - 300px)",
              }
              : {}
          }
        >
          {leadData ? (
            !props.ambassador ? (
              <FormEditLead
                data={leadData}
                onSubmit={saveLead}
                formRequestErrors={formRequestErrors}
              />
            ) : (
              <FormEditLeadByAmbassador
                data={leadData}
                dataAmbassador={props.ambassador}
                onSubmit={saveLeadByAmbassador}
                formRequestErrors={formRequestErrors}
              />
            )
          ) : (
            <Loading />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}
